<template lang="pug">
.l-hamburger(
  @click="click"
)
  transition(
    @enter="openEnter"
    @leave="openLeave"
  )
    .l-hamburger__open(v-show="!store.ui.state.nav")
      .l-hamburger__open__line1
      .l-hamburger__open__line2
      .l-hamburger__open__line3
  transition(
    @enter="closeEnter"
    @leave="closeLeave"
  )
    .l-hamburger__close(v-show="store.ui.state.nav")
      .l-hamburger__close__line1
      .l-hamburger__close__line2
  .l-hamburger__menu MENU
  
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-hamburger
  display block
  // background-color #CCC
  no_highlight()
  +pc()
    posfr(15px,15px,50)
    wh(50px,50px)
    cursor pointer
    // transition opacity 200ms
    transition transform 250ms $easeOutBack
    &:hover
      // opacity 0.85
      transform scale(1.1)
  +sp()
    posfr(30px,40px,50)
    wh(75px,75px)

  &__open
    &__line1,
    &__line2,
    &__line3
      background-color #515151
      +pc()
        wh(40px,3px)
      +sp()
        wh(65px,4px)
    &__line1
      transform-origin right
      +pc()
        posr(5px,6px)
      +sp()
        posr(5px,6px)
    &__line2
      transform-origin left
      +pc()
        pos(5px,16px)
      +sp()
        pos(5px,21px)
    &__line3
      transform-origin right
      +pc()
        posr(5px,26px)
      +sp()
        posr(5px,36px)
  &__close
    &__line1,
    &__line2
      background-color #515151
      +pc()
        wh(40px,3px)
      +sp()
        wh(65px,4px)
    &__line1
      transform rotate(27deg)
      +pc()
        pos(5px,16px)
      +sp()
        pos(5px,22px)
    &__line2
      transform rotate(-27deg)
      +pc()
        posr(5px,16px)
      +sp()
        posr(5px,22px)
  &__menu
    +pc()
      bg2('../../assets/images/ui-nav-menu.png')
      posb(5px,4px,1)
    +sp()
      bg2('../../assets/images/ui-nav-menu.png',1.6)
      posb(5px,5px,1)
</style>

<script>
import gsap from 'gsap'
import { defineComponent, computed, reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'


export default defineComponent({
  name:'Hamburger',

  components:{},

  setup(props, context) {
    // const router = useRouter()
    // const route = useRoute()
    const store = useStore()

    const click = ()=> {
      store.ui.state.nav = !store.ui.state.nav
    }

    const openEnter = (el, done)=> {
      gsap.to(
        el.getElementsByClassName('l-hamburger__open__line1')[0],
        {scaleX:1,duration:0.2,delay:0.2,ease:'power2.out'}
      )
      gsap.to(
        el.getElementsByClassName('l-hamburger__open__line3')[0],
        {scaleX:1,duration:0.2,delay:0.2,ease:'power2.out',onComplete:()=>{
          done()
        }}
      )
      // gsap.to(
      //   el.getElementsByClassName('l-hamburger__open__line2')[0],
      //   {scaleX:1,duration:0.2,delay:0.2,ease:'power2.out',onComplete:()=>{
      //     done()
      //   }}
      // )
    }
    const openLeave = (el, done)=> {
      gsap.to(
        el.getElementsByClassName('l-hamburger__open__line1')[0],
        {scaleX:0,duration:0.2,ease:'power2.out'}
      )
      gsap.to(
        el.getElementsByClassName('l-hamburger__open__line3')[0],
        {scaleX:0,duration:0.2,ease:'power2.out',onComplete:()=>{
          done()
        }}
      )
      // gsap.to(
      //   el.getElementsByClassName('l-hamburger__open__line2')[0],
      //   {left:5,scaleX:0,duration:0.2,ease:'power2.out',delay:0.0,onComplete:()=>{
      //     done()
      //   }}
      // )
    }

    const closeEnter = (el, done)=> {
      const tl1 = gsap.timeline()
      tl1.fromTo(
        el.getElementsByClassName('l-hamburger__close__line1')[0],
        {rotate:'0deg',scaleX:1},
        {rotate:'27deg',scaleX:1,duration:0.2,delay:0.2,ease:'power2.out',overwrite:false}
      )
      // tl1.to(
      //   el.getElementsByClassName('l-hamburger__close__line1')[0],
      //   {rotate:'27deg',scaleX:1,duration:0.1,delay:0.2,ease:'power2.out',overwrite:false}
      // )
      const tl2 = gsap.timeline({delay:0.0})
      tl2.fromTo(
        el.getElementsByClassName('l-hamburger__close__line2')[0],
        {rotate:'0deg',scaleX:1},
        {rotate:'-27deg',scaleX:1,duration:0.2,delay:0.2,ease:'power2.out',overwrite:false}
      )
      // tl2.to(
      //   el.getElementsByClassName('l-hamburger__close__line2')[0],
      //   {rotate:'-27deg',scaleX:1,duration:0.1,delay:0.2,ease:'power2.out',overwrite:false}
      // )
    }
    const closeLeave = (el, done)=> {
      gsap.to(
        el.getElementsByClassName('l-hamburger__close__line1')[0],
        {rotate:'0deg',scaleX:1,duration:0.2,ease:'power2.out',overwrite:false}
      )
      gsap.to(
        el.getElementsByClassName('l-hamburger__close__line2')[0],
        {rotate:'0deg',scaleX:1,duration:0.2,ease:'power2.out',delay:0.0,overwrite:false,onComplete:()=>{
          done()
        }}
      )
    }

    return{
      store,
      click,
      openEnter,
      openLeave,
      closeEnter,
      closeLeave
    }
  }
})
</script>
